import { useEffect, useState } from "react";
import { UtilityTeamMember } from "../../../../../model/utility-users/utility-team-member";

import styles from "./teammember.module.scss";
import { ThreeDotsIcon } from "../../../../../assets/icons";
import { TeamMemberAvatar } from "./TeamMemberAvatar";
import TeamMemberOptionsDialog from "./TeamMemberOptionsDialog";
import InvitedTeamMemberOptionsDialog from "./InvitedTeamMemberOptionsDialog";
import { hasAnyPermission } from "../../../../../guards/common/authentification-functions";
import { UtilityPermissions } from "../../../../../model/permissions/permissions";

type TeamMemberRowProps = {
    User: UtilityTeamMember
    IsInvite?: boolean
}

export const TeamMemberRow = (props: TeamMemberRowProps) => {

    const [dialogOpen, setDialogOpen] = useState(false);

    const toggleDialog = () => {
        setDialogOpen(!dialogOpen);
    };

    const closeDialog = () => {
        setDialogOpen(false);
    };

    return (
        <>
            <div className={styles.TeamMemberRow}>
                <TeamMemberAvatar {...props} />
                <span className={styles.name}> {props.User.firstName} {props.User.lastName}</span>
                <span> {props.User.email}</span>
                <span> {props.User.phoneNumber}</span>
                <span> {props.User.roles.at(0)?.name}</span>
                {hasAnyPermission([UtilityPermissions.EditUtilityUser, UtilityPermissions.DeleteUtilityUser]) && <div onClick={toggleDialog} className={styles.optionsButton} >

                    <ThreeDotsIcon />
                    {dialogOpen &&
                        (props.IsInvite ?
                        <InvitedTeamMemberOptionsDialog user={props.User} onClose={closeDialog} />
                        :
                        <TeamMemberOptionsDialog user={props.User} onClose={closeDialog} /> )
                    }
                </div>}

            </div>
        </>


    );
};
